export const VEHICLE_STATUS = {
  ENABLED: 1,
  DISABLED: 2
}

export const VEHICLE_MODULES = ['cm-frotas', 'cm-crono', 'cm-taxas']

export const VEHICLE_STATUS_OPTIONS = [
  { id: VEHICLE_STATUS.ENABLED, friendlyName: 'Ativo' },
  { id: VEHICLE_STATUS.DISABLED, friendlyName: 'Inativo' }
]

// O terceiro estado: o veículo foi EXCLUÍDO da conta (#80140 / #81586).
// Não é um entity_status — o veículo excluído não tem cadastro, então não há id
// que o represente. Vai para a API como `q[entity_status_id]=deleted`, que
// seleciona os registros pela ausência do veículo. Valor desconhecido nesse
// filtro devolve 422, nunca a lista inteira.
export const VEHICLE_STATUS_DELETED = 'deleted'

// As opções do filtro, no formato [label, value] que o Filter usa. Centralizar
// aqui é o que faz a opção nova acender nas três listagens de uma vez.
export const VEHICLE_STATUS_FILTER_TABLE = [
  ['Todos', ''],
  ...VEHICLE_STATUS_OPTIONS.map(s => [s.friendlyName, String(s.id)]),
  ['Excluídos', VEHICLE_STATUS_DELETED]
]

// O rótulo da coluna Status do Veículo de uma linha. A resposta traz `vehicles`
// em alguns endpoints e `vehicle` em outros. A AUSÊNCIA do veículo é o estado
// excluído: as três listagens sempre pedem o veículo em `methods`, então não vir
// significa que ele não existe mais. Antes caía no traço, e era esse "-" que
// impedia auditar o registro (#80140).
export function vehicleStatusRowLabel(row, entityStatusNames = {}) {
  const vehicle = row.vehicles || row.vehicle
  if (!vehicle) return 'Excluído'

  const status = vehicle.entityStatus || vehicle.entity_status
  const friendlyName = status && (status.friendlyName || status.friendly_name)
  const statusId = vehicle.entityStatusId != null ? vehicle.entityStatusId : vehicle.entity_status_id

  return friendlyName || entityStatusNames[statusId] || '-'
}
